const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
};

const waitForImagesToLoad = (callback) => {
    const images = $('.c-banner-home img');
    let loaded = 0;
    const total = images.length;

    if (total === 0) {
        callback();
        return;
    }

    images.each(function () {
        const img = new Image();
        img.src = $(this).attr('src');
        img.onload = img.onerror = () => {
            loaded++;
            if (loaded === total) {
                callback();
            }
        };
    });
};

// Background image management is now handled directly in swiper.js

const init = () => {
    const normaliseContentHeight = () => {
        const $component = $('.c-banner-home');
        const $slides = $component.find('.c-swiper__slide');
        let maxContentHeight = 0;
        let maxBookHeight = 0;

        // Check if normalization is needed based on viewport width
        const needsHeight = window.innerWidth <= 1132;

        if (needsHeight) {
            const results = [];
            $slides.each(function () {
                const $el = $(this);
                const $container = $el.find('.c-banner-home__container');
                const $content = $el.find('.c-banner-home__content');
                const $book = $el.find('.c-banner-home__books');

                // Reset styles for accurate height calculation
                $content.removeAttr('style');
                $book.removeAttr('style');

                const bookHeight = Math.ceil($book.height());
                if (bookHeight > maxBookHeight) maxBookHeight = bookHeight;

                const contentHeight = Math.ceil($content.height());
                if (contentHeight > maxContentHeight) maxContentHeight = contentHeight;

                results.push({
                    $container,
                    $content,
                    $book,
                    contentHeight,
                    bookHeight,
                });
            });

            // Apply calculated heights to all slides
            results.forEach(({ $content, $book, bookHeight }) => {
                const bookHeightDiff = maxBookHeight - bookHeight;
                $content.height(maxContentHeight);
            });

            // Update the Swiper instance if it exists
            const swiperInstance = $component[0]?.swiper;
            if (swiperInstance) {
                swiperInstance.update();
            }
        } else {
            // When viewport is wide enough, reset all content heights to natural size
            $slides.each(function () {
                const $content = $(this).find('.c-banner-home__content');
                const $book = $(this).find('.c-banner-home__books');
                
                // Remove any artificially set heights
                $content.removeAttr('style');
                $book.removeAttr('style');
            });

            // Update the Swiper instance if it exists
            const swiperInstance = $component[0]?.swiper;
            if (swiperInstance) {
                swiperInstance.update();
            }
        }
    };

    // Recalculate heights on window resize (with debounce)
    $(window).on('resize', debounce(normaliseContentHeight, 200));

    window.addEventListener('load', function () {
        const $component = $('.c-banner-home');
        if ($component.length < 1) return;

        // Wait for images to load, then normalize content height
        waitForImagesToLoad(() => {
            normaliseContentHeight();
        });
    });
};

export default init;
